import { Tab, Tabs } from '@mui/material';
import React from 'react';

interface CustomPageTabsProps {
  pageTypes: string[];
  selectedPageType: string;
  onChange: (event: React.SyntheticEvent, newValue: string) => void;
}

const CustomPageTabs: React.FC<CustomPageTabsProps> = ({
  pageTypes,
  selectedPageType,
  onChange,
}) => {
  return (
    <Tabs
      value={selectedPageType}
      onChange={onChange}
      variant="scrollable"
      scrollButtons="auto"
      sx={{
        '& .MuiTabs-indicator': {
          backgroundColor: '#1976d2',
        },
      }}
    >
      {pageTypes.map((pageType) => (
        <Tab
          key={pageType}
          value={pageType}
          label={pageType}
          sx={{
            textTransform: 'none',
            minWidth: 'auto',
            padding: '12px 16px',
            '&.Mui-selected': {
              color: '#1976d2',
            },
          }}
        />
      ))}
    </Tabs>
  );
};

export default CustomPageTabs;
